import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function StudentHeader({ title, showBack = false, onBack, lang = 'ar' }) {
  const navigate = useNavigate();
  const isAr = lang === 'ar';

  const containerStyle = {
    background: 'white',
    border: '1px solid #E5E7EB',
    borderRadius: 18,
    boxShadow: '0 4px 20px rgba(5,150,105,.12)',
    padding: '14px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
  };

  const logoSection = (
    <div onClick={() => navigate('/student/dashboard')} style={{ display: 'flex', alignItems: 'center', gap: 8, direction: 'ltr', cursor: 'pointer' }}>
      <img src="/jahbath-hat.png" width={34} height={34} alt="Jahbath" />
      <span style={{ fontFamily: 'Sora, sans-serif', fontWeight: 800, fontSize: 18 }}>
        <span style={{ color: '#1E3A5F' }}>Jah</span>
        <span style={{ color: '#059669' }}>bath</span>
      </span>
      {title && (
        <>
          <span style={{ color: '#E5E7EB', margin: '0 8px' }}>|</span>
          <span style={{ color: '#1E3A5F', fontWeight: 600, fontSize: 14 }}>{title}</span>
        </>
      )}
    </div>
  );

  const backBtn = showBack ? (
    <button
      onClick={onBack}
      style={{
        minWidth: 90,
        height: 38,
        borderRadius: 10,
        border: '1.5px solid #059669',
        background: '#F0FDF4',
        color: '#059669',
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'Sora, sans-serif',
        fontSize: 14,
      }}
    >
      {isAr ? 'رجوع ←' : '← Back'}
    </button>
  ) : null;

  return (
    <header style={containerStyle}>
      {isAr ? <>{logoSection}{backBtn}</> : <>{backBtn}{logoSection}</>}
    </header>
  );
}
